import { render, staticRenderFns } from "./blade-activity.vue?vue&type=template&id=4be48946&scoped=true&"
import script from "./blade-activity.vue?vue&type=script&lang=js&"
export * from "./blade-activity.vue?vue&type=script&lang=js&"
import style0 from "./blade-activity.vue?vue&type=style&index=0&id=4be48946&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be48946",
  null
  
)

export default component.exports